<template>
    <span>
        <b-button @click="showDialog">{{$t('newEntry.button')}}</b-button>
        <b-modal v-model="dialogVisible" :title="title"
                :cancel-title="$t('newEntry.buttons.cancel')" :ok-disabled="$v.$invalid | saving" @ok="createEntry"
                no-close-on-backdrop :no-close-on-esc="saving" :cancel-disabled="saving">
            <template v-slot:modal-ok>
                 {{$t('newEntry.buttons.ok')}}
                <font-awesome-icon v-if="saving" spin icon="spinner-third"></font-awesome-icon>
            </template>
            <p v-html="$t('newEntry.instructions')"></p>
            <b-form-group :label="$t('newEntry.gnLabel')">
                <b-input v-model.trim="gn" :placeholder="$t('newEntry.gnPlaceholder')"
                        :state="!$v.gn.$invalid"></b-input>
                <b-form-invalid-feedback v-html="gnFeedback"></b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('newEntry.initialsLabel')">
                <b-input v-model.trim="initials" :placeholder="$t('newEntry.initialsPlaceholder')"
                        :state="!$v.initials.$invalid"></b-input>
                <b-form-invalid-feedback v-html="initialsFeedback"></b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('newEntry.snLabel')">
                <b-input v-model.trim="sn" :placeholder="$t('newEntry.snPlaceholder')"
                        :state="!$v.sn.$invalid"></b-input>
                <b-form-invalid-feedback v-html="snFeedback"></b-form-invalid-feedback>
            </b-form-group>
            <b-form-group :label="$t('newEntry.mailLabel')">
                <b-input v-model.trim="mail" :placeholder="$t('newEntry.mailPlaceholder')"
                        :state="!$v.mail.$invalid"></b-input>
                <b-form-invalid-feedback v-html="mailFeedback"></b-form-invalid-feedback>
            </b-form-group>
        </b-modal>
    </span>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'newAddrEntry',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      gn: '',
      initials: '',
      sn: '',
      mail: '',
      dialogVisible: false
    };
  },
  props: {
    scope: String
  },
  validations: {
    gn: {},
    initials: {},
    sn: {},
    mail: {
      required,
      email
    }
  },
  methods: {
    showDialog() {
      this.gn = '';
      this.initials = '';
      this.sn = '';
      this.mail = '';

      this.dialogVisible = true;
    },
    createEntry(bvModalEvent) {
      const entry = {
        cn: this.cn,
        gn: this.gn,
        initials: this.initials,
        sn: this.sn,
        mail: this.mail
      };
      bvModalEvent.preventDefault();
      this.saving = true;

      this.$store.dispatch('createAddrEntry', { scope: this.scope, entry })
        .then(d => {
          this.$emit('newEntry', d);
          this.dialogVisible = false;
        })
        .catch(e => {
          this.$dialog.alert(this.$t('newEntry.saveError', { error: e.message }));
        })
        .finally(() => {
          this.saving = false;
        });
    }
  },
  computed: {
    gnFeedback() {
      return '';
    },
    initialsFeedback() {
      return '';
    },
    snFeedback() {
      return '';
    },
    mailFeedback() {
      let fb = '';
      if (!this.$v.mail.required) {
        fb += this.$t('newEntry.errors.emailRequired');
      }
      if (!this.$v.mail.email) {
        fb += this.$t('newEntry.errors.emailFormat');
      }
      return fb;
    },
    cn() {
      let cn = this.gn;
      cn = cn + (cn ? ' ' : '') + this.initials;
      cn = cn + (cn ? ' ' : '') + this.sn;
      return cn || this.mail;
    },
    title() {
      if (this.cn) {
        return this.$t('newEntry.titleName', { cn: this.cn });
      } else {
        return this.$t('newEntry.title');
      }
    }
  }
};
</script>

<style scoped>
    button {
        margin-left: 0.3em;
    }
</style>
